import "./rera.css";

export default function Rera() {
  return (
    <footer className="rera-footer" id="rera">

      <div className="rera-wrapper">

        <h2 className="rera-title">
          MahaRERA Information
        </h2>

        <p className="rera-subtitle">
          Scan below QR codes for official project details and verification
        </p>

        <div className="rera-grid">

          {/* RERA 1 */}
          <div className="rera-card">
            <img
              src="/images/PristineRera.png"
              alt="RERA Agent QR"
            />
            <p>Project Rera</p>
          </div>

          {/* RERA 2 */}
          <div className="rera-card">
            <img
              
              src="/images/maharera-agent.png"
              alt="RERA Project QR"
            />
            <p>Channel Patner</p>
          </div>

        </div>

        <div className="rera-bottom">
          © {new Date().getFullYear()} Pristine Kyra. All Rights Reserved.
        </div>

      </div>

    </footer>
  );
}